<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <discount-select v-model="discountSaved" :disabled="isDisabled"></discount-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">- Or -</v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-sheet color="grey lighten-4" class="pa-4">
            <v-form ref="form">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="discount.label" label="Label"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-radio-group v-model="discount.type" :column="false">
                    <v-radio label="Percent" value="percent" class="mr-2"></v-radio>
                    <v-radio label="Amount" value="amount"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="discount.amount" label="Value" type="number"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    outlined
                    color="accent"
                    :disabled="!discount.label || !discount.type || !discount.amount"
                    @click.stop="create()"
                  >Create discount</v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-sheet>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import DiscountSelect from "@components/forms/select/Discount";

export default {
  components: {
    DiscountSelect
  },
  props: ["order"],
  data() {
    return {
      discount: {},
      discountSaved: null,
      predefineDiscount: null
    };
  },
  computed: {
    isDisabled: function() {
      if (this.order.statusId != "new") return true;
      return false;
    }
  },
  methods: {
    create: function() {
      this.loading = true;
      this.$store
        .dispatch("orderDiscounts/create", {
          orderId: this.order.id,
          model: this.discount
        })
        .then(result => {
          this.$emit("orderUpdate", result);
          this.$refs.form.reset()
          this.discountSaved = null
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  watch: {
    discountSaved: function(model) {
      this.discount.label = model.label;
      this.discount.type = model.type;
      this.discount.amount = model.amount;
    }
  }
};
</script>
